var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.906,
    height: 27.906,
    viewBox: "0 0 27.906 27.906",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-check-circle",
    "data-name": "Icon awesome-check-circle",
    d: "M28.469,14.516A13.953,13.953,0,1,1,14.516.562,13.953,13.953,0,0,1,28.469,14.516ZM12.9,21.9,23.254,11.551a.9.9,0,0,0,0-1.273L21.981,9.005a.9.9,0,0,0-1.273,0l-8.443,8.443L8.323,13.506a.9.9,0,0,0-1.273,0L5.777,14.779a.9.9,0,0,0,0,1.273L11.629,21.9a.9.9,0,0,0,1.273,0Z",
    transform: "translate(-0.563 -0.563)",
    fill: "#40c100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/InfoIcon.65100e6fda544ad2eee68ca767a8da70.svg";
export { ForwardRef as ReactComponent };